/**
 * A tapped streak push (EN-11238): OneSignal's click listener records it here
 * and useStreakSync acts on it once the player is signed in and ops.streaks is
 * on, so a tap that cold-starts the app is not lost before the UI is ready.
 * Last call opens the app (the lobby); freeze covered also opens the account
 * panel with the streak card expanded.
 */
export type StreakPushKind = 'lastcall' | 'freeze';

export const STREAK_PUSH_OPENED = 'streak-push-opened';

let pending: StreakPushKind | null = null;

/** `additionalData` of a tapped notification; ignores anything not a streak push. */
export function noteStreakPushOpened(data: unknown) {
  const kind = (data as { streakPush?: unknown } | null)?.streakPush;
  if (kind !== 'lastcall' && kind !== 'freeze') return;
  pending = kind;
  window.dispatchEvent(new CustomEvent(STREAK_PUSH_OPENED));
}

/** The tapped push not handled yet, once. */
export function takeStreakPushOpened(): StreakPushKind | null {
  const kind = pending;
  pending = null;
  return kind;
}
